<template>
  <div class="bg-EXPONDO-grey-5 relative w-full flex flex-col">
    <a
      :href="link"
      :aria-label="title"
      class="absolute w-full h-full"
    />
    <ImgView
      :src="image"
      :height="80"
      :alt="imageAlt"
      img-classes="w-full h-20 mx-auto object-contain"
    />
    <p class="text-center text-sm font-semibold py-[0.625rem]">
      {{ title }}
    </p>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'CategoryCard',

  props: {
    link: {
      type: String,
      required: true,
    },
    altImageText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const i18n = useI18n();

    const imageAlt = computed(() => {

      if (props.altImageText) {

        return props.altImageText;
      
      }

      return `${props.title} - ${i18n.t('Product Image')}`;
    
    });

    return {
      imageAlt,
    };
  
  },
});

</script>
